import React from 'react'
import { Link } from 'react-router'
import { prefixLink } from 'gatsby-helpers'
import Helmet from 'react-helmet'
import { config } from 'config'

export default class Index extends React.Component {

  constructor() {
    super()
    this.state = { index: 0}
  }

  _fire(index) {
    this.setState({index: index})
  }

  render() {
    return (
      <div
        style={{
          position: 'relative',
          height: 690,
          padding: '30px 0 0 74px'
        }}
      >
        <h2>EXHIBITIONS & AWARDS</h2>

        { this.state.index !== 0 &&
          <img style={{position: 'absolute', zIndex: 999}} src={`/assets/exhibitions/${this.state.index}.jpg`} />
        }

				<div className='exhi-box'>
          2010-2016 <br/>
          Several photos selected for book covers. The most successful being 'Two houses in a snow storm' for Jennifer McMahon's 'The Winter People' nomminated for Boston Globe best book of the year.
        </div>

				<div className='exhi-box'>
          <div className='exhi-button' onMouseOver={()=>this._fire(1)} 
            onMouseLeave={()=>this._fire(0)}>VIEW</div>
					2008 January-February <br/>
					'TWO SAILBOATS' Selected for Planes, Trains & Automobiles. <br/>
					The Center for Fine Art Photography. Fort Collins, Colorado
				</div>

				<div className='exhi-box'>
          <div className='exhi-button' onMouseOver={()=>this._fire(2)}
            onMouseLeave={()=>this._fire(0)}>VIEW</div>
          2007 December <br/>
          'THE CORNFIELD' Jury award, Mont St. Hilaire Competition
        </div>

				<div className='exhi-box'>
          <div className='exhi-button' onMouseOver={()=>this._fire(3)}
            onMouseLeave={()=>this._fire(0)}>VIEW</div>
          <div className='exhi-button' style={{top:40}} onMouseOver={()=>this._fire(4)}
            onMouseLeave={()=>this._fire(0)}>VIEW</div>
          2006 December <br/>
          'THE MYSTIC MOUNTAIN' Cover photo, Mont St. Hilaire Calendar <br/>
          ' MONT ST. HILAIRE' 3rd Place. Mont St. Hilaire Competition <br/>
          ' MONT ST. HILAIRE' 3rd Place, November photo. Mont St. Hilaire Calendar
        </div>

				<div className='exhi-box'>
          2006 October <br/>
          One Man Show. Victoria Gallery. Westmount. Qc
        </div>

				<div className='exhi-box'>
          <div className='exhi-button' onMouseOver={()=>this._fire(5)}
            onMouseLeave={()=>this._fire(0)}>VIEW</div>
          2005 December <br/>
          'BENDING THE LIGHT' Jury award, Mont St. Hilaire Competition
        </div>

			</div>
		)
  }
}



// WEBPACK FOOTER //
// ./exhibitions.js